import { createFileRoute } from "@tanstack/react-router";
import { AdminEventMetadataTab } from "@/components/admin/pages/AdminEventMetadataTab";

export const Route = createFileRoute("/pulse-ops-x7k2/target-cities/event-metadata")({
  component: AdminEventMetadataTab,
});
